import { render, staticRenderFns } from "./UldkSearchSettings.vue?vue&type=template&id=1cda2547&"
import script from "./UldkSearchSettings.vue?vue&type=script&lang=js&"
export * from "./UldkSearchSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports